<template>
  <div class="jcbox" v-if="show">
    <div class="jcbox-inner" @click.stop="handleClose">
      <img v-if="dev == 'ios'"  class="item" src="@/assets/xhs/7.png" alt="" />
      <img v-if="dev == 'android'"  class="item" src="@/assets/xhs/8.png" alt="" />
    </div>
  </div> 
</template>

<script>
import { getDevType } from "@/utils";

export default {
  data() {
    return {
      show: false,
      dev: "",
    };
  },
  methods: {
    handleClose() {
      console.log("handleClose");
      this.show = false;
    },
    handleOpen() {
      this.show = true;
    },
  },
  created() {
    this.dev = getDevType();
  },
};
</script>
<style lang="scss">
.jcbox {
  width: 100vw;
  height: 100vh;
  display: flex;
  padding: 45px;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.69);
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  
  .jcbox-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .item {
    width: 296px;
    height: 441px;
  }
}
</style>
